/*
 * @Author: your name
 * @Date: 2021-12-27 14:14:29
 * @LastEditTime: 2022-01-11 18:47:12
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \bidding-systemd:\项目\engineer-management-system\src\views\PC\Purchase\add-purchase\add-purchase-api.js
 */
import * as API from '@/api/index'

/* 查询项目下拉列表 */
export const findProjectDownList = (params) => {
    return API.POST('/Mh01ProjectController/findProjectInfoList', params, {}, true)
}

/* 查询项目分类字典 */
export const findProjectCategory = (type, params) => {
    return API.POST(`/Mh01ProjectController/basedict/?kind=${type}`, params, {}, true)
}

/* 查看采购单明细 */
export const queryPurchaseDetail = (params) => {
    return API.POST(`/MhProjectPurchaseController/queryPurchaseDetail`, params, {}, true)
}

/* 新增采购单 */
export const insertPurchaseSheet = (params) => {
    return API.POST(`/MhProjectPurchaseController/insertPurchaseSheet`, params, {}, true)
}

/* 删除采购单 */
export const delPurchase = (params) => {
    return API.POST(`/MhProjectPurchaseController/delPurchase`, params, {}, true)
}


/* 修改采购单 */
export const updatePurchase = (params) => {
    return API.POST(`/MhProjectPurchaseController/updatePurchase`, params, {}, true)
}

/* 导入采购单数据 */
export const importPurchase = (params) => {
    return API.POST(`/MhProjectPurchaseController/importPurchase`, params, {}, true)
}


/* 重新发起采购单 */
export const resetPurchaseSheet = (params) => {
    return API.POST(`/MhProjectPurchaseController/resetPurchaseSheet`, params, {}, true)
}


/* 新增采购单日志 */
export const addActualHour = (params) => {
    return API.POST('/Mh02ActualHourController/addActualHour', params, {}, true)
}

/* 查看采购单日志 */
export const queryPurchaseLog = (params) => {
    return API.POST(`/MhProjectPurchaseController/queryPurchaseLog`, params, {}, true)
}

/* 点击发送采购单邮件通知 */
export const sendPurchaseEmail = (params) => {
    return API.POST(`/MhProjectPurchaseController/sendPurchaseEmail`, params, {}, true)
}



